<template>
  <div class="auth-layout">
    <slot />
  </div>
</template>